import axiosInstance from '../api/axiosInstance';

const ENDPOINT = '/AdresAnalizi';

/**
 * AdresAnalizi API - Mahalle analizi için adres/ziyaret verilerini döner.
 * @param {Object} params - AdresAnaliziRequestDto
 * @param {string} params.Basla - Başlangıç tarihi (zorunlu)
 * @param {string} params.Bitir - Bitiş tarihi (zorunlu)
 * @param {string} [params.Ilce] - İlçe filtresi
 * @param {string[]} [params.Mahalleler] - Mahalle listesi
 * @param {string[]} [params.IslemTurleri] - İşlem türleri
 * @param {boolean|null} [params.GidildiMi] - true: sadece gidilenler, false: sadece gidilmeyenler, null: hepsi
 * @param {string} [params.Search] - Metin araması
 * @param {number} [params.PageNumber] - Sayfa numarası
 * @param {number} [params.PageSize] - Sayfa boyutu
 * @param {boolean} [params.NegatifZiyaretleriFiltrele] - Negatif ziyaretleri hariç tut
 */
export const getAdresAnalizi = async (params) => {
  const payload = {
    Basla: params.Basla,
    Bitir: params.Bitir,
    Ilce: params.Ilce || undefined,
    Mahalleler: params.Mahalleler && params.Mahalleler.length > 0 ? params.Mahalleler : undefined,
    IslemTurleri: params.IslemTurleri && params.IslemTurleri.length > 0 ? params.IslemTurleri : [],
    GidildiMi: params.GidildiMi ?? null,
    Search: params.Search || '',
    PageNumber: params.PageNumber ?? 1,
    PageSize: params.PageSize ?? 50,
    NegatifZiyaretleriFiltrele: params.NegatifZiyaretleriFiltrele ?? false,
  };
  const response = await axiosInstance.post(ENDPOINT, payload);
  return response.data;
};
